<div
  [style.width]="width"
  class="fk-navbar">
  <div class="fk-navbar--header-container">
    @if (headerTpl) {
      <ng-container *ngTemplateOutlet="headerTpl"></ng-container>
    } @else {
      <div class="fk-navbar--header">
        <button
          class="fk-btn fk-btn fk-btn-giant fk-btn-ghost fk-navbar--toggle-btn"
          (click)="toggle()">
          <fk-icon [name]="expanded ? 'menu-opened' : 'menu-closed'" [size]="24"></fk-icon>
        </button>
        <a
          class="fk-mv4 fk-mh3 fk-navbar--logo-link"
          [class.fk-hidden]="!expanded"
          href="/">
          <ng-container *ngTemplateOutlet="logoImgTpl"></ng-container>
        </a>
      </div>
    }
  </div>
  <div class="fk-navbar--menu fk-flex-column">
    @if (selectOptions && selectOptions.length) {
      <div class="fk-navbar--menu-select fk-m3">
        <button
          [fkDropdown]="selectExpanded"
          [fkDropdownTemplate]="selectExpandedTpl"
          [fkDropdownDirection]="expanded ? 'bottom' : 'right'"
          class="fk-btn fk-btn-giant fk-btn-ghost fk-btn--full-size fk-navbar--menu-select-btn"
          [class.fk-navbar--menu-select-btn__opened]="selectExpanded"
          (click)="toggleSelect($event)">
          <div class="fk-navbar-menu-selected-option">{{ getSelectedOptionShortName() }}</div>
          @if (expanded) {
            <div class="fk-subtitle1 fk-navbar-menu-selected-option-label fk-ml3">
              {{ getSelectedOptionName() }}
            </div>
            <fk-icon name="chevron-up-down"></fk-icon>
          }
        </button>

        <ng-template #selectExpandedTpl>
          <div
            [class.fk-navbar-menu-select--options-container__short]="!expanded"
            class="fk-navbar-menu-select--options-container">
            <ul class="fk-navbar-menu-select--options fk-p3">
              @for (option of selectOptions; track option.id) {
                <li class="fk-navbar-menu-select--options-item">
                  <button
                    class="fk-btn fk-btn-giant fk-btn-ghost fk-btn--full-size fk-navbar--menu-select-btn fk-navbar-menu-select--options-item-btn"
                    [class.fk-navbar-menu-select--options-item-btn__selected]="option.id === selectedOption"
                    (click)="selectOption(option.id)">
                    <span class="fk-navbar--menu-select-btn-label">{{ option.label }}</span>
                    @if (option.id === selectedOption) {
                      <span class="fk-navbar-menu-select--options-item-check">
                        <fk-icon name="checkmark"></fk-icon>
                      </span>
                    }
                  </button>
                </li>
              }
            </ul>
          </div>
        </ng-template>

        <!--@if (selectExpanded) {
          <div
            [class.fk-navbar-menu-select&#45;&#45;options-container__short]="!expanded"
            [class.fk-pt2]="expanded"
            class="fk-navbar-menu-select&#45;&#45;options-container">
            <ul class="fk-navbar-menu-select&#45;&#45;options fk-p3">
              @for (option of selectOptions; track option.id) {
                <li class="fk-navbar-menu-select&#45;&#45;options-item">
                  <button
                    class="fk-btn fk-btn-giant fk-btn-ghost fk-btn&#45;&#45;full-size fk-navbar&#45;&#45;menu-select-btn fk-navbar-menu-select&#45;&#45;options-item-btn"
                    [class.fk-navbar-menu-select&#45;&#45;options-item-btn__selected]="option.id === selectedOption"
                    (click)="selectOption(option.id)">
                    <span class="fk-navbar&#45;&#45;menu-select-btn-label">{{ option.label }}</span>
                    @if (option.id === selectedOption) {
                      <span class="fk-navbar-menu-select&#45;&#45;options-item-check">
                        <fk-icon name="checkmark"></fk-icon>
                      </span>
                    }
                  </button>
                </li>
              }
            </ul>
          </div>
        }-->
      </div>
    }

    <section class="fk-navbar--menu__overflow">
      <div
        [class.fk-p3]="expanded"
        [class.fk-pv3]="!expanded">
        <fk-tree-view
          [minimized]="!expanded"
          [items]="menuItems"></fk-tree-view>
      </div>
      @if (secondaryMenuItems && secondaryMenuItems.length) {
        <div
          class="fk-navbar--menu__secondary"
          [class.fk-p3]="expanded"
          [class.fk-pv3]="!expanded">
          <fk-tree-view
            [minimized]="!expanded"
            [items]="secondaryMenuItems"></fk-tree-view>
        </div>
      }
    </section>
  </div>
  <div
    class="fk-navbar__notifications fk-notifications"
    [ngClass]="{'fk-notifications--menu-expanded': !expanded}"
    *ngIf="invates.length > 0 && canAcceptInvites"
  >
    <div
      [fkDropdown]="notificationsExpanded"
      [fkDropdownTemplate]="notifications"
      [fkHasBaseClass]="false"
      [fkDropdownWidthAsEl]="expanded"
      [fkDropdownDirection]="expanded ? 'top' : 'topRight'"
      class="fk-notifications__label fk-p3"
      [ngClass]="{ 'fk-notifications__label--active': notificationsExpanded }"
      (click)="notificationsExpanded = !notificationsExpanded"
    >
      <fk-icon class="fk-notifications__icon" name="bell" [size]="24"></fk-icon>
      <p class="fk-notifications__text">
        {{ i18nText['title'] }}
      </p>
      <div class="fk-notifications__counter">{{ invates.length }}</div>
    </div>
    <ng-template #notifications>
      <div
        class="fk-notifications__popup fk-p3"
      >
        <ul>
          <li *ngFor="let invite of invates" class="fk-ph3">
          <span
            [fkTooltip]="invite.description"
            [fkTooltipDelay]="0"
          >
            {{ invite.description }}
          </span>
            <button
              (click)="clickInvite(true, invite.id)"
              class="fk-notifications__popup-button fk-btn fk-btn-ghost fk-btn-small"
              type="button"
              fkTooltip="{{ i18nText['accept'] }}"
            >
              <fk-icon name="check"></fk-icon>
            </button>
            <button
              (click)="clickInvite(false, invite.id)"
              class="fk-notifications__popup-button fk-notifications__popup-button--denger fk-btn fk-btn-ghost fk-btn-small"
              type="button"
              fkTooltip="{{ i18nText['reject'] }}"
            >
              <fk-icon name="close"></fk-icon>
            </button>
          </li>
        </ul>
      </div>
    </ng-template>
  </div>
  <div class="fk-navbar--footer fk-p3">
    <div
      class="fk-navbar--profile"
    >
      <button
        class="fk-btn fk-btn fk-btn-giant fk-btn-ghost fk-navbar--profile-btn"
        [class.fk-navbar--profile-btn__expanded]="profileExpanded"
        [fkDropdown]="profileExpanded"
        [fkDropdownTemplate]="profilePanel"
        [fkHasBaseClass]="false"
        [fkDropdownDirection]="expanded ? 'top' : 'topRight'"
        (click)="toggleProfile()">
        <div class="fk-navbar--profile-photo fk-p1">
          @if (profile && profile.photo) {
            <!-- Photo should be here -->
          } @else {
            {{ getShortenedName(profile.name || profile.email) }}
          }
        </div>
        @if (expanded) {
          <div class="fk-navbar--profile-names fk-ml3">
            @if (profile && profile.name) {
              <span class="fk-navbar--profile-name">
              {{ profile.name }}
            </span>
            }
            @if (profile && profile.email) {
              <span class="fk-navbar--profile-email">
              {{ profile.email }}
            </span>
            }
          </div>
          <fk-icon name="chevron-up-down"></fk-icon>
        }
      </button>

      <ng-template #profilePanel>
        <div class="fk-navbar--profile-panel fk-p3">
          <div *ngIf="profileInfo" class="fk-navbar__account fk-pb4 fk-mb4">
            <div class="fk-navbar__account--photo fk-mr3 fk-p1">
              @if (profile && profile.photo) {
                <!-- Photo should be here -->
              } @else {
                {{ getShortenedName(profile.name || profile.email) }}
              }
            </div>
            <div class="fk-navbar__account--details fk-mr3 fk-paragraph2">
              <div class="fk-navbar__account--name">{{ profileInfo.name }}</div>
              <div class="fk-navbar__account--email">{{ profileInfo.email }}</div>
            </div>
            <div class="fk-navbar__account--edit">
              <button class="fk-navbar__account--btn-edit" (click)="openEditProfile()">
                <fk-icon class="fk-navbar__account--edit-icon" [size]="24" name="edit" />
              </button>
            </div>
          </div>
          <div class="fk-navbar--profile-lang">
            <ng-content select="[fkNavbarLang]"></ng-content>
          </div>
          <ng-content select="[fkNavbarActions]"></ng-content>
          @if (version && appName) {
            <div
              class="fk-navbar--profile-version fk-text fk-ph3 fk-mt3">
              @if (version) {
                {{ version }}
                <div class="fk-navbar--profile-version-separator"></div>
              }
              @if (appName) {
                {{ appName }}
              }
            </div>
          }
        </div>
      </ng-template>
    </div>
  </div>
</div>
